import { useFormContext } from "react-hook-form";
import { TextField, Box, InputAdornment } from "@mui/material";
import { useTranslatedMessages } from "@/multiLanguage/i18n";

interface InputCreatinineDataProps {
    creatinineRequired?: boolean;
}

function CreatinineData({ creatinineRequired = false }: InputCreatinineDataProps) {
    const { register, formState } = useFormContext();
    const lang = useTranslatedMessages();

    return (
        <Box height={65}>
            <TextField
                {...register("creatinine", {
                    valueAsNumber: true,
                    required: {
                        value: creatinineRequired,
                        message: creatinineRequired
                            ? lang.scales.scaleWithComponentShared.creatinine.errorText
                            : " ",
                    },
                    validate: (value) => {
                        if (!value) {
                            return true;
                        }
                        if (value < 0.1 || value > 10.3) {
                            return lang.scales.scaleWithComponentShared.creatinine.errorText;
                        }
                        return true;
                    },
                })}
                inputProps={{
                    "data-testid": "form-component-creatinine",
                    step: ".01",
                    onWheel: (event: any) => {
                        event.target.blur();
                    },
                }}
                label={
                    <>
                        {lang.scales.scaleWithComponentShared.creatinine.label}
                        {creatinineRequired ? "*" : null}
                    </>
                }
                type="number"
                fullWidth
                error={!!formState.errors.creatinine}
                helperText={
                    formState.errors.creatinine ? String(formState.errors.creatinine.message) : " "
                }
                InputProps={{
                    endAdornment: <InputAdornment position="end">mg/dL</InputAdornment>,
                }}
                FormHelperTextProps={{
                    style: {
                        fontSize: "0.65rem",
                    },
                }}
            />
        </Box>
    );
}

export default CreatinineData;
